import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import ElectionMap from "@/components/map/Map.vue";
import { Election, Party } from "@/types";
import { useMainStore } from "@/stores/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'Election',
  props: {
    election: {}
  },
  setup(__props: any) {

const props = __props;

const store = useMainStore();

const parties = computed(() => {
    if (!props.election.totals) {
        return [];
    } else {
        return props.election.totals
            .filter((t) => t.votes > store.threshold)
            .map((t) => {
                return t.party;
            });
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Election",
    style: _normalizeStyle({ width: _unref(store).width + 'px' })
  }, [
    _createVNode(ElectionMap, {
      election: __props.election,
      parties: parties.value
    }, null, 8, ["election", "parties"])
  ], 4))
}
}

})